import axios from "axios";
import { siteConfig } from "@/src/config/site";

const axiosInstance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

// ─── Request Interceptor ──────────────────────────────────────
// بيضيف "website" تلقائياً في كل request
// القيمة ثابتة من siteConfig.websiteKey لأنها مرتبطة بتكامل الـ backend الحالي
// اليوزر مش بيشوفها — بس الـ backend محتاجها يعرف الطلب جاي منين
axiosInstance.interceptors.request.use((config) => {
  // JSON body
  if (
    config.data &&
    typeof config.data === "object" &&
    !(config.data instanceof FormData)
  ) {
    // لو website موجود صريح في الـ body (زي add-referral) → متضيفوش تاني
    if (!config.data.website) {
      config.data = {
        ...config.data,
        website: siteConfig.websiteKey,
      };
    }
  }

  // FormData (send-message endpoint)
  if (config.data instanceof FormData) {
    if (!config.data.has("website")) {
      config.data.append("website", siteConfig.websiteKey);
    }
  }

  return config;
});

export default axiosInstance;
